module.exports = __webpack_public_path__ + "img/maker_mella.414e6416.jpg";